import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CustomNextArrow, CustomPrevArrow } from "../../utility/CustomArrow";
import { FaPause } from "react-icons/fa";
import { FaPlay } from "react-icons/fa";
import { IoVolumeMediumSharp } from "react-icons/io5";
import { IoVolumeMute } from "react-icons/io5";
import topServiceData from "../../text-files/homepage/topVideos.json";
import { useLanguage } from "../../contextApi/languageContext";

const Services = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [playingIndex, setPlayingIndex] = useState(null);
  const [unmutedIndex, setUnmutedIndex] = useState(null);
  const { language } = useLanguage();
  const content = topServiceData[language];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMouseEnter = (index) => {
    if (isMobile) return;
    setHoveredIndex(index);
    setUnmutedIndex(null);
  };

  const handleMouseLeave = () => {
    if (isMobile) return;
    setHoveredIndex(null);
  };

  const toggleMute = (index) => {
    setUnmutedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleVideoToggle = (index) => {
    setPlayingIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleSlideChange = () => {
    setPlayingIndex(null);
    setUnmutedIndex(null);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    beforeChange: handleSlideChange,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className=" py-5">
      <div className="container">
        <div className="text-center mb-5">
          {language === "ar" ? (
            <h2 className="fw-bold display-5" style={{ color: "#c69933" }}>
              أفضل الخدمات لدينا
            </h2>
          ) : (
            <h2 className="fw-bold display-5" style={{ color: "#c69933" }}>
              Our Best Services
            </h2>
          )}
        </div>

        <Slider {...settings}>
          {content.map((service, index) => (
            <div key={index} className="px-3">
              <div
                className="card border-1"
                style={{
                  borderRadius: "16px",
                  overflow: "hidden",
                  marginBottom: "20px",
                }}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                <div
                  className="position-relative"
                  style={{
                    height: isMobile ? "520px" : "580px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#f8f9fa",
                    overflow: "hidden",
                  }}
                >
                  {(!isMobile && hoveredIndex === index) ||
                  (isMobile && playingIndex === index) ? (
                    <video
                      className="w-100 h-100"
                      autoPlay
                      loop
                      muted={unmutedIndex !== index}
                      style={{ objectFit: "cover" }}
                    >
                      <source src={service.Video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <img
                      src={service?.thumbnail}
                      alt={service.Title}
                      className="w-100 h-100"
                      style={{ objectFit: "cover" }}
                      loading="lazy"
                    />
                  )}

                  {isMobile && (
                    <button
                      className="btn btn-light position-absolute bottom-3 start-50 translate-middle-x rounded-circle shadow"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleVideoToggle(index);
                      }}
                      style={{
                        width: "50px",
                        height: "50px",
                        zIndex: 2,
                      }}
                    >
                      {playingIndex === index ? <FaPause /> : <FaPlay />}
                    </button>
                  )}

                  {((!isMobile && hoveredIndex === index) ||
                    (isMobile && playingIndex === index)) && (
                    <button
                      className="btn btn-light position-absolute rounded-circle shadow"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleMute(index);
                      }}
                      style={{
                        width: "50px",
                        height: "50px",
                        zIndex: 2,
                        ...(isMobile
                          ? { top: "10px", right: "10px" }
                          : { bottom: "10px", right: "10px" }),
                      }}
                    >
                      {unmutedIndex === index ? (
                        <IoVolumeMediumSharp className="fs-3" />
                      ) : (
                        <IoVolumeMute className="fs-3" />
                      )}
                    </button>
                  )}
                </div>

                <div
                  className="p-4 text-center"
                  style={{
                    backgroundColor: "#fff",
                    height: isMobile ? "180px" : "200px",
                  }}
                >
                  <h4
                    className="fw-bold mb-2"
                    style={{ color: "#343a40", fontSize: "1.6rem" }}
                  >
                    {service.heading}
                  </h4>

                  {language === "ar" ? (
                    <p className="text-muted" style={{ fontSize: "1rem" }}>
                      {service.smallDescription}
                    </p>
                  ) : (
                    <p className="text-muted" style={{ fontSize: "1rem" }}>
                      {service.smallDescription}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <hr
        className=" mx-auto"
        style={{
          marginTop: "4rem",
          height: "1px",
          backgroundColor: "#b78c35",
          border: "none",
        }}
      />
    </section>
  );
};

export default Services;
